module.exports = __webpack_public_path__ + "media/images/brand/img-statement-5082639dcb6f55b5028368f2e7e91d17.png";